<template>
  <Card class="mt-4 shadow-none p-0">
    <template v-slot:title>
      <InlineMessage severity="info">
        Se ha enviado un código a la bandeja de su correo electrónico
      </InlineMessage>
    </template>
    <template v-slot:content>
      <div class="p-fluid">
        <div class="field">
          <label>Ingresar el código <span>*</span></label>
          <InputText autocomplete="code" v-model="code" class="mt-2" />
          <span class="error-message">
            {{ errors.code }}
          </span>
        </div>
      </div>

      <div class="p-fluid mt-3">
        <label>Contraseña nueva<span>*</span></label>
        <InputText
          autocomplete="new-password"
          v-model="password"
          type="password"
          class="mt-2"
        />
        <span class="error-message">
          {{ errors.password }}
        </span>
      </div>

      <div class="p-fluid mt-3">
        <label for="confirmPassword"
          >Confirmar contraseña nueva<span>*</span></label
        >
        <InputText
          v-model="confirmPassword"
          autocomplete="new-password"
          type="password"
          class="mt-2"
        />
        <span class="error-message">
          {{ errors.confirmPassword }}
        </span>
      </div>
    </template>
    <template v-slot:footer>
      <div class="grid grid-nogutter justify-content-between">
        <i></i>
        <Button
          class="font-light text-sm"
          label="Confirmar"
          @click="nextPage()"
          icon="pi pi-angle-right"
          iconPos="right"
        />
      </div>
    </template>
  </Card>
</template>
<script setup lang="ts">
  import { useForm } from 'vee-validate'
  import { computed, ref } from 'vue'
  import * as yup from 'yup'

  const codeSchema = yup.string().trim().required('El código es requerido')

  const passwordSchema = yup
    .string()
    .required('La contraseña es requerida')
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .test(
      'password-complexity',
      'La contraseña debe contener al menos una letra mayúscula y un número',
      (value) => {
        // La expresión regular para validar al menos una letra mayúscula y un número
        const regex = /^(?=.*[A-Z])(?=.*\d)/
        return regex.test(value)
      }
    )

  const confirmPasswordSchema = yup
    .string()
    .required('La confirmación de la contraseña es requerida')
    .test(
      'passwords-match',
      'Las contraseñas deben coincidir',
      function (value: string): boolean {
        return value === password.value
      }
    )
    .min(8, 'La contraseña debe tener al menos 8 caracteres')

  const { values, errors, defineField } = useForm({
    validationSchema: yup.object({
      code: codeSchema,
      password: passwordSchema,
      confirmPassword: confirmPasswordSchema,
    }),
  })

  const [code, codeAttrs] = defineField('code', {
    validateOnModelUpdate: false,
  })

  const [password, passwordAttrs] = defineField('password', {
    validateOnModelUpdate: true,
  })

  const [confirmPassword, confirmPasswordAttrs] = defineField(
    'confirmPassword',
    {
      validateOnModelUpdate: true,
    }
  )

  const emits = defineEmits(['next-page'])

  const nextPage = async () => {
    // Validate the fields
    await codeSchema.validate(code.value.trim())
    await passwordSchema.validate(password.value.trim())
    await confirmPasswordSchema.validate(confirmPassword.value.trim())

    //if someof the validations fail, the errors will be set automatically
    if (Object.keys(errors.value).length > 0) {
      console.error('Validation errors:', errors)
      return
    }

    emits('next-page', {
      formData: { code: code.value, newPassword: password.value },
      pageIndex: 1,
    })
  }

  const isValidToUptade = computed(
    () => code.value && confirmPassword.value === password.value
  )
</script>
<style scoped>
  .error-message {
    padding-top: 5px;
    color: rgb(234, 68, 68);
    font-size: 12px;
  }
</style>
